<template>
  <footer class="footer">
    <div class="footer__content">
      <div class="footer__logo">
        <a href="/">
          <img
            loading="lazy"
            src="../../assets/logo_integra.png"
            alt="Logo Leveros Integra"
          />
        </a>
        <div class="footer__climatizacao">
          <p>Leveros Climatização</p>
          <div class="footer__socialMedias">
            <a
              href="https://www.instagram.com/leverosoficial/"
              target="_blank"
              rel="noopener"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="23px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 89.758 89.758"
                style="enable-background: new 0 0 89.758 89.758"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M58.255,23.88H31.503c-4.27,0-7.744,3.474-7.744,7.744v26.752c0,4.27,3.474,7.745,7.744,7.745
		h26.752c4.27,0,7.745-3.474,7.745-7.745V31.624C66,27.354,62.526,23.88,58.255,23.88z M44.879,58.906
		c-7.667,0-13.905-6.238-13.905-13.906c0-7.667,6.238-13.905,13.905-13.905c7.668,0,13.906,6.238,13.906,13.905
		C58.785,52.667,52.546,58.906,44.879,58.906z M59.232,33.97c-1.815,0-3.291-1.476-3.291-3.29c0-1.814,1.476-3.29,3.291-3.29
		c1.814,0,3.29,1.476,3.29,3.29C62.522,32.494,61.046,33.97,59.232,33.97z"
                  />
                  <path
                    d="M44.879,36.971c-4.426,0-8.03,3.602-8.03,8.028c0,4.428,3.604,8.031,8.03,8.031
		c4.428,0,8.029-3.603,8.029-8.031C52.908,40.574,49.306,36.971,44.879,36.971z"
                  />
                  <path
                    d="M44.879,0C20.094,0,0,20.094,0,44.879c0,24.785,20.094,44.879,44.879,44.879
		c24.785,0,44.879-20.094,44.879-44.879C89.758,20.094,69.664,0,44.879,0z M71.875,58.376c0,7.511-6.109,13.62-13.62,13.62H31.503
		c-7.51,0-13.62-6.109-13.62-13.62V31.624c0-7.51,6.11-13.62,13.62-13.62h26.752c7.511,0,13.62,6.11,13.62,13.62V58.376z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/LeverosOficial"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="21px"
                viewBox="0 0 438.536 438.536"
                style="enable-background: new 0 0 438.536 438.536"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M414.41,24.123C398.333,8.042,378.963,0,356.315,0H82.228C59.58,0,40.21,8.042,24.126,24.123
		C8.045,40.207,0.003,59.576,0.003,82.225v274.084c0,22.647,8.042,42.018,24.123,58.102c16.084,16.084,35.454,24.126,58.102,24.126
		h274.084c22.648,0,42.018-8.042,58.095-24.126c16.084-16.084,24.126-35.454,24.126-58.102V82.225
		C438.532,59.576,430.49,40.204,414.41,24.123z M373.155,225.548h-49.963V406.84h-74.802V225.548H210.99V163.02h37.401v-37.402
		c0-26.838,6.283-47.107,18.843-60.813c12.559-13.706,33.304-20.555,62.242-20.555h49.963v62.526h-31.401
		c-10.663,0-17.467,1.853-20.417,5.568c-2.949,3.711-4.428,10.23-4.428,19.558v31.119h56.534L373.155,225.548z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/leveros"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="21px"
                viewBox="0 0 438.536 438.536"
                style="enable-background: new 0 0 438.536 438.536"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M414.41,24.123C398.333,8.042,378.963,0,356.315,0H82.228C59.58,0,40.21,8.042,24.126,24.123
		C8.045,40.207,0.003,59.576,0.003,82.225v274.084c0,22.647,8.042,42.018,24.123,58.102c16.084,16.084,35.454,24.126,58.102,24.126
		h274.084c22.648,0,42.018-8.042,58.095-24.126c16.084-16.084,24.126-35.454,24.126-58.102V82.225
		C438.532,59.576,430.49,40.204,414.41,24.123z M133.618,367.157H67.666V169.016h65.952V367.157z M127.626,132.332
		c-6.851,6.567-15.893,9.851-27.124,9.851h-0.288c-10.848,0-19.648-3.284-26.407-9.851c-6.76-6.567-10.138-14.703-10.138-24.41
		c0-9.897,3.476-18.083,10.421-24.556c6.95-6.471,15.942-9.708,26.98-9.708c11.039,0,19.89,3.237,26.553,9.708
		c6.661,6.473,10.088,14.659,10.277,24.556C137.899,117.625,134.477,125.761,127.626,132.332z M370.873,367.157h-65.952v-105.92
		c0-29.879-11.036-44.823-33.116-44.823c-8.374,0-15.42,2.331-21.128,6.995c-5.715,4.661-9.996,10.324-12.847,16.991
		c-1.335,3.422-1.999,8.75-1.999,15.981v110.775h-65.952c0.571-119.529,0.571-185.579,0-198.142h65.952v27.974
		c13.867-21.681,33.558-32.544,59.101-32.544c22.84,0,41.21,7.52,55.104,22.554c13.895,15.037,20.841,37.214,20.841,66.519v113.64
		H370.873z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/channel/UCn_BBxqK-BTixt8dIZNPMNQ"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Layer_1"
                width="30px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <g>
                    <g>
                      <path
                        class="st0"
                        d="M508.9879,188.7359c0-60.8382-49.3194-110.1576-110.1576-110.1576h-285.709
				c-60.8382,0-110.1576,49.3194-110.1576,110.1576v133.9018c0,60.8382,49.3194,110.1575,110.1576,110.1575h285.709
				c60.8382,0,110.1576-49.3194,110.1576-110.1575V188.7359z M328.7266,262.4327l-113.9452,62.4955
				c-4.9525,2.6798-9.4079-0.9073-9.4079-6.5379V190.1117c0-5.704,4.5931-9.2821,9.5501-6.46l114.7268,65.7831
				C334.7195,252.3227,333.8572,259.6571,328.7266,262.4327z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </div>
        <div class="footer__solar">
          <p>Leveros Energia Solar</p>
          <div class="footer__socialMedias">
            <a
              href="https://www.instagram.com/leverossolar/"
              target="_blank"
              rel="noopener"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="23px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 89.758 89.758"
                style="enable-background: new 0 0 89.758 89.758"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M58.255,23.88H31.503c-4.27,0-7.744,3.474-7.744,7.744v26.752c0,4.27,3.474,7.745,7.744,7.745
		h26.752c4.27,0,7.745-3.474,7.745-7.745V31.624C66,27.354,62.526,23.88,58.255,23.88z M44.879,58.906
		c-7.667,0-13.905-6.238-13.905-13.906c0-7.667,6.238-13.905,13.905-13.905c7.668,0,13.906,6.238,13.906,13.905
		C58.785,52.667,52.546,58.906,44.879,58.906z M59.232,33.97c-1.815,0-3.291-1.476-3.291-3.29c0-1.814,1.476-3.29,3.291-3.29
		c1.814,0,3.29,1.476,3.29,3.29C62.522,32.494,61.046,33.97,59.232,33.97z"
                  />
                  <path
                    d="M44.879,36.971c-4.426,0-8.03,3.602-8.03,8.028c0,4.428,3.604,8.031,8.03,8.031
		c4.428,0,8.029-3.603,8.029-8.031C52.908,40.574,49.306,36.971,44.879,36.971z"
                  />
                  <path
                    d="M44.879,0C20.094,0,0,20.094,0,44.879c0,24.785,20.094,44.879,44.879,44.879
		c24.785,0,44.879-20.094,44.879-44.879C89.758,20.094,69.664,0,44.879,0z M71.875,58.376c0,7.511-6.109,13.62-13.62,13.62H31.503
		c-7.51,0-13.62-6.109-13.62-13.62V31.624c0-7.51,6.11-13.62,13.62-13.62h26.752c7.511,0,13.62,6.11,13.62,13.62V58.376z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/leverossolar/"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="21px"
                viewBox="0 0 438.536 438.536"
                style="enable-background: new 0 0 438.536 438.536"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M414.41,24.123C398.333,8.042,378.963,0,356.315,0H82.228C59.58,0,40.21,8.042,24.126,24.123
		C8.045,40.207,0.003,59.576,0.003,82.225v274.084c0,22.647,8.042,42.018,24.123,58.102c16.084,16.084,35.454,24.126,58.102,24.126
		h274.084c22.648,0,42.018-8.042,58.095-24.126c16.084-16.084,24.126-35.454,24.126-58.102V82.225
		C438.532,59.576,430.49,40.204,414.41,24.123z M373.155,225.548h-49.963V406.84h-74.802V225.548H210.99V163.02h37.401v-37.402
		c0-26.838,6.283-47.107,18.843-60.813c12.559-13.706,33.304-20.555,62.242-20.555h49.963v62.526h-31.401
		c-10.663,0-17.467,1.853-20.417,5.568c-2.949,3.711-4.428,10.23-4.428,19.558v31.119h56.534L373.155,225.548z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/leveros"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="21px"
                viewBox="0 0 438.536 438.536"
                style="enable-background: new 0 0 438.536 438.536"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M414.41,24.123C398.333,8.042,378.963,0,356.315,0H82.228C59.58,0,40.21,8.042,24.126,24.123
		C8.045,40.207,0.003,59.576,0.003,82.225v274.084c0,22.647,8.042,42.018,24.123,58.102c16.084,16.084,35.454,24.126,58.102,24.126
		h274.084c22.648,0,42.018-8.042,58.095-24.126c16.084-16.084,24.126-35.454,24.126-58.102V82.225
		C438.532,59.576,430.49,40.204,414.41,24.123z M133.618,367.157H67.666V169.016h65.952V367.157z M127.626,132.332
		c-6.851,6.567-15.893,9.851-27.124,9.851h-0.288c-10.848,0-19.648-3.284-26.407-9.851c-6.76-6.567-10.138-14.703-10.138-24.41
		c0-9.897,3.476-18.083,10.421-24.556c6.95-6.471,15.942-9.708,26.98-9.708c11.039,0,19.89,3.237,26.553,9.708
		c6.661,6.473,10.088,14.659,10.277,24.556C137.899,117.625,134.477,125.761,127.626,132.332z M370.873,367.157h-65.952v-105.92
		c0-29.879-11.036-44.823-33.116-44.823c-8.374,0-15.42,2.331-21.128,6.995c-5.715,4.661-9.996,10.324-12.847,16.991
		c-1.335,3.422-1.999,8.75-1.999,15.981v110.775h-65.952c0.571-119.529,0.571-185.579,0-198.142h65.952v27.974
		c13.867-21.681,33.558-32.544,59.101-32.544c22.84,0,41.21,7.52,55.104,22.554c13.895,15.037,20.841,37.214,20.841,66.519v113.64
		H370.873z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/channel/UCn_BBxqK-BTixt8dIZNPMNQ"
              target="_blank"
              rel="noopener"
              ><svg
                version="1.1"
                id="Layer_1"
                width="30px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <g>
                    <g>
                      <path
                        class="st0"
                        d="M508.9879,188.7359c0-60.8382-49.3194-110.1576-110.1576-110.1576h-285.709
				c-60.8382,0-110.1576,49.3194-110.1576,110.1576v133.9018c0,60.8382,49.3194,110.1575,110.1576,110.1575h285.709
				c60.8382,0,110.1576-49.3194,110.1576-110.1575V188.7359z M328.7266,262.4327l-113.9452,62.4955
				c-4.9525,2.6798-9.4079-0.9073-9.4079-6.5379V190.1117c0-5.704,4.5931-9.2821,9.5501-6.46l114.7268,65.7831
				C334.7195,252.3227,333.8572,259.6571,328.7266,262.4327z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="footer__drops">
        <div class="footer__CallCenter">
          <div class="CallCenter__climatizacao">
            <div class="footer__title">
              <p>Atendimento Climatização</p>
            </div>
            <div class="footer__items footer__items--bold">
              <span>
                <router-link to="/CallCenter"
                  >Central de Atendimento</router-link
                >
              </span>
              <p>SAC:</p>
              <p><a href="tel:08007704885">0800 770 4885</a></p>
              <p>E-mail:</p>
              <p><a href="mailto:sac@leveros.com.br">sac@leveros.com.br</a></p>
              <p>Horário de Atendimento:</p>
              <p>Seg a Sex das 8h às 18h</p>
            </div>
          </div>
          <div class="CallCenter__solar">
            <div class="footer__title">
              <p>Atendimento Energia Solar</p>
            </div>
            <div class="footer__items footer__items--bold">
              <span>
                <router-link to="/CallCenter"
                  >Central de Atendimento</router-link
                >
              </span>
              <p>SAC:</p>
              <p><a href="tel:47999909651">(47) 99990-9651</a></p>
              <p>Suporte Técnico:</p>
              <p><a href="tel:47997401311">(47) 99740-1311</a></p>
              <p>E-mail:</p>
              <p>
                <a href="mailto:comercial.solar@leveros.com.br"
                  >comercial.solar@leveros.com.br</a
                >
              </p>
              <p>Horário de Atendimento:</p>
              <p>Seg a Sex das 8h às 18h</p>
            </div>
          </div>
        </div>
        <div class="footer__institutional">
          <div class="footer__title">
            <p>Institucional</p>
          </div>
          <div class="footer__items">
            <p>
              <a
                target="_blank"
                rel="noopener"
                href="https://www.leveros.com.br/institucional/quem-somos"
                >Quem Somos</a
              >
            </p>
            <p>
              <a
                target="_blank"
                rel="noopener"
                href="https://www.leveros.com.br/central-de-atendimento/lojas-fisicas"
                >Nossas Lojas</a
              >
            </p>
            <p>
              <a
                target="_blank"
                rel="noopener"
                href="https://jobs.kenoby.com/leveros"
                >Trabalhe Conosco</a
              >
            </p>
            <p>
              <a
                target="_blank"
                rel="noopener"
                href="https://www.leverosintegra.com.br/download/manuais/Leveros/codigo-de-conduta-leveros.pdf"
                >Código de Conduta</a
              >
            </p>
            <p>
              <a href="/panel" target="_blank" rel="noopener">Acessar Painel</a>
            </p>
          </div>
        </div>
        <div class="footer__partners">
          <div class="footer__title">
            <p>Soluções e Parcerias</p>
          </div>
          <div class="footer__items">
            <p>
              <a
                href="https://www.leveros.com.br/empresas/seja-nosso-revendedor"
                target="_blank"
                rel="noopener"
                >Seja Parceiro Climatização Revendedor</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br/empresas/seja-nosso-instalador"
                target="_blank"
                rel="noopener"
                >Seja Parceiro Climatização Instalador</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br/energia-solar/fotovoltaica/integrador"
                target="_blank"
                rel="noopener"
                >Seja Parceiro Energia Solar Revendedor</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br/empresas"
                target="_blank"
                rel="noopener"
                >Leveros Empresas</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br"
                target="_blank"
                rel="noopener"
                >Leveros Climatização</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br/energia-solar/fotovoltaica/integrador"
                target="_blank"
                rel="noopener"
                >Leveros Solar</a
              >
            </p>
            <p>
              <a
                href="https://www.leveros.com.br/empresas/profiz"
                target="_blank"
                rel="noopener"
                >Profiz</a
              >
            </p>
          </div>
        </div>

        <div class="footer__payment">
          <div class="footer__title">
            <p>Formas de Pagamento</p>
          </div>
          <div class="footer__items footer__items--methods">
            <ul>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 291.76 91.31"
                  width="40px"
                >
                  <title>Cartão Visa</title>
                  <g id="Camada_Visa" data-name="Camada Visa">
                    <g id="Camada_Visa-2" data-name="Camada Visa">
                      <path
                        d="M119.26,0,104.62,91.12H128L142.66,0Zm70.6,37.12c-8.18-4-13.19-6.76-13.19-10.9.1-3.76,4.24-7.6,13.49-7.6A40.73,40.73,0,0,1,207.58,22l2.12.95,3.18-19.07a59.07,59.07,0,0,0-21-3.76c-23.11,0-39.39,12-39.49,29.2C152.2,42,164,49,172.91,53.27,182,57.6,185,60.41,185,64.25c-.1,5.91-7.32,8.63-14.06,8.63-9.34,0-14.35-1.4-22-4.7l-3.08-1.4L142.66,86.6c5.5,2.44,15.61,4.6,26.1,4.71,24.56,0,40.55-11.84,40.75-30.15C209.6,51.11,203.35,43.41,189.86,37.12Zm83-36.84H254.78c-5.58,0-9.82,1.61-12.24,7.33L207.78,91.12h24.56L239.11,73h27.48l3.51,18.15h21.66Zm-27,54.51c.47,0,9.43-29.51,9.43-29.51l7.13,29.51ZM85.06,0,62.13,61.91,59.63,49.7c-4.24-14.09-17.53-29.4-32.37-37L48.26,91H73l36.8-91H85.06Z"
                      ></path>
                      <path
                        d="M51.92,11.75C50.13,4.8,44.43.12,36.69,0H.37L0,1.7c28.33,7,52.11,28.47,59.82,48.69Z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 243.5 182.63"
                  width="40px"
                >
                  <title>Cartão MasterCard</title>
                  <g id="Camada_Mastercard" data-name="Camada Mastercard">
                    <g id="Camada_Mastercard-2" data-name="Camada Mastercard">
                      <g id="Camada_Mastercard-3" data-name="Camada Mastercard">
                        <g
                          id="Camada_Mastercard-4"
                          data-name="Camada Mastercard"
                        >
                          <path
                            d="M46.38,182.05H42.16V171.54a10.15,10.15,0,0,0-.41-2.77,3.4,3.4,0,0,0-3.29-2.49c-3.11-.22-5.12,1.45-5.19,4.59-.11,3.43,0,6.87-.06,10.3V182H28.92V171.67a10.5,10.5,0,0,0-.4-2.88,3.4,3.4,0,0,0-3.3-2.48c-3.11-.21-5.08,1.46-5.19,4.56-.1,3.46,0,6.94,0,10.37V182H15.89v-19.2H20V165l.12.07a6.51,6.51,0,0,1,6.09-2.75A7,7,0,0,1,32,165.7a1.34,1.34,0,0,0,.19-.17,7.52,7.52,0,0,1,7.51-3.17c4.32.48,6.69,3.25,6.73,7.74v10.37C46.38,181,46.38,181.48,46.38,182.05Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M227.62,182.05h-4.15v-2.21a2,2,0,0,0-.29.21,7.62,7.62,0,0,1-7.2,2.43c-5.35-.71-8.81-5.52-8.25-11.16a9.54,9.54,0,0,1,4.84-7.76,9.24,9.24,0,0,1,6.76-1,6.83,6.83,0,0,1,3.62,2.07c.12.13.23.3.34.45l.13-.07v-9.9h4.15Zm-15.56-9.63a7.35,7.35,0,0,0,0,.77,5.81,5.81,0,0,0,9.09,4.49A6.06,6.06,0,0,0,223.7,172a5.77,5.77,0,0,0-6.66-5.69C214.11,166.63,212,169.15,212.06,172.42Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M65.87,182V180h-.15c-2.34,2.65-5.31,3.11-8.55,2.26a9.53,9.53,0,0,1-7-8.41,10.72,10.72,0,0,1,2.25-8.1,9.48,9.48,0,0,1,9.89-3A7.83,7.83,0,0,1,65.84,165v-2.18H70V182Zm.24-9.61c0-5.33-4.92-7.41-8.61-5.5-2.35,1.21-3.11,3.39-3.11,5.91a5.82,5.82,0,0,0,7.5,5.58,5.88,5.88,0,0,0,4.21-6Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M184.46,164.92v-2.07h4.15V182h-4.15v-2.22l-.32.28a7.52,7.52,0,0,1-7.11,2.39,9.56,9.56,0,0,1-8.3-9.41,10,10,0,0,1,3.63-8.66,9.17,9.17,0,0,1,8.48-1.75A8.12,8.12,0,0,1,184.46,164.92Zm-5.58,1.34c-3.44,0-5.89,2.56-5.89,6.22a5.84,5.84,0,0,0,5.43,6.22h.45c3.37,0,5.83-2.61,5.83-6.22s-2.4-6.22-5.8-6.22Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M131.49,174.06H117a5.25,5.25,0,0,0,5.19,4.72,9.12,9.12,0,0,0,5.71-1.67l.47-.32,2.07,3.11c-.68.45-1.31.92-2,1.28a12.2,12.2,0,0,1-8.74,1,9.13,9.13,0,0,1-6.85-7.88,12.27,12.27,0,0,1,.65-6.22,9.2,9.2,0,0,1,9.79-5.75c4.53.44,7.38,3.78,8,8C131.44,171.57,131.41,172.78,131.49,174.06ZM127,170.73a4.71,4.71,0,0,0-4.66-4.68,4.88,4.88,0,0,0-5.19,4.54h0v.12Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M74.21,180,76,177a36.8,36.8,0,0,0,3.56,1.48,10.05,10.05,0,0,0,5.35.1,3.76,3.76,0,0,0,1.17-.52,1.62,1.62,0,0,0-.25-3,25.87,25.87,0,0,0-3.36-.78,31.94,31.94,0,0,1-3.88-.91,5,5,0,0,1-3.69-4.9,5.53,5.53,0,0,1,3.56-5.33,10.21,10.21,0,0,1,4.15-.84,15.56,15.56,0,0,1,7.15,1.4c.26.12.52.28.78.43.08,0,.16.11.29.2l-1.7,3.18c-1.41-.45-2.75-.92-4.15-1.27a7.07,7.07,0,0,0-3.84,0,3.43,3.43,0,0,0-1.22.65,1.56,1.56,0,0,0,.46,2.74,20.08,20.08,0,0,0,2.74.61c1.34.28,2.72.44,4,.83,2.62.8,4,2.44,4.15,4.69a5.41,5.41,0,0,1-3.53,5.68,14.09,14.09,0,0,1-13.37-1.29l-.13-.11A.13.13,0,0,1,74.21,180Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M98,166.63H94.21v-3.82h3.84V157h4.24v5.79h6.82v3.86h-6.66l-.09.11c0,3.11-.08,6.22,0,9.34.07,2,1.51,2.87,3.71,2.42a28.81,28.81,0,0,0,2.77-.86l.79,2.34c.4,1.21.41,1.22-.76,1.73a10.37,10.37,0,0,1-6.16.67,5.25,5.25,0,0,1-4.49-5c-.12-1.16-.12-2.34-.13-3.53v-7A1.32,1.32,0,0,0,98,166.63Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M164.55,176.93l2,3.34a9,9,0,0,1-3.91,2,12.73,12.73,0,0,1-6.29-.12,9.51,9.51,0,0,1-7-9,10.1,10.1,0,0,1,3-8.18,9.78,9.78,0,0,1,6.15-2.63,10.48,10.48,0,0,1,8,2.26l-1.92,3.24a22.82,22.82,0,0,0-2.87-1.27c-2.51-.73-4.83-.43-6.67,1.65-2.32,2.63-2.07,8.7,2.62,10.11a7.52,7.52,0,0,0,6.29-1Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M140,182.05h-4.15V162.83h4.09v2.07l.11.1c2.07-2.93,4.87-3.11,8-2.18l-1.29,3.93a7.26,7.26,0,0,0-3.51-.38,3.35,3.35,0,0,0-2.9,2.56,10,10,0,0,0-.33,2.49v9.95Z"
                            style="fill: #7e7d81"
                          ></path>
                          <path
                            d="M194.24,162.82h4.09v2.07c2.19-2.83,5-3,8.1-2.07l-1.24,3.82a25.49,25.49,0,0,0-2.66-.32,3.68,3.68,0,0,0-4,3.34v.06a11.59,11.59,0,0,0-.12,1.75V182h-4.15Z"
                            style="fill: #7e7d81"
                          ></path>
                        </g>
                      </g>
                      <path
                        d="M171.75,0a71.5,71.5,0,0,0-50,20.31,71.69,71.69,0,0,1,0,102.87A71.74,71.74,0,1,0,171.75,0Z"
                        style="fill: #9d9ba1"
                      ></path>
                      <path
                        d="M100,71.75a71.52,71.52,0,0,1,21.75-51.44,71.75,71.75,0,1,0,0,102.87A71.52,71.52,0,0,1,100,71.75Z"
                        style="fill: #5a595c"
                      ></path>
                      <path
                        d="M143.5,71.75a71.52,71.52,0,0,0-21.75-51.44,71.69,71.69,0,0,0,0,102.87A71.52,71.52,0,0,0,143.5,71.75Z"
                        style="fill: #7e7d81"
                      ></path>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 145.3 39.13"
                  width="50px"
                >
                  <title>Cartão Hipercard</title>
                  <g id="Camada_Hipercard" data-name="Camada Hipercard">
                    <g id="Camada_Hipercard-2" data-name="Camada Hipercard">
                      <g id="Camada_Hipercard-3" data-name="Camada Hipercard">
                        <g id="Camada_Hipercard-4" data-name="Camada Hipercard">
                          <path
                            d="M0,28.7q1.48-5.36,2.82-12T5.2,2.59l1.31.15H8a11.54,11.54,0,0,0,1.26-.15Q8.39,5.34,7.51,9.67l-.09.41-.75,3.68L9,13.83c2.18,0,3.62.08,4.32.08q2.15,0,7-.13h.66l.87-4.2q.48-2.41.69-3.94t.33-3c.5.08.91.12,1.21.15a7.83,7.83,0,0,0,.84,0h.69l1.34-.15q-2,7.54-3.34,14.29T21.73,28.7l-1.32-.16H19a10.47,10.47,0,0,0-1.31.15c.47-1.75.86-3.31,1.19-4.66s.58-2.43.75-3.25l1-5H6.3L5.42,20c-.24,1.27-.47,2.62-.71,4.06s-.45,3-.68,4.66L2.85,28.6a7.94,7.94,0,0,0-.8,0H1.26A10.08,10.08,0,0,0,0,28.75Zm30.43-25a1.78,1.78,0,0,1,1.69-1.87h.18a1.79,1.79,0,0,1,1.34.49,1.88,1.88,0,0,1,.47,1.38A1.83,1.83,0,0,1,33.58,5a1.77,1.77,0,0,1-1.32.55A1.74,1.74,0,0,1,31,5,1.85,1.85,0,0,1,30.43,3.7Zm-4.32,25Q27.65,22.77,28.5,18a53.36,53.36,0,0,0,.92-7.61l1,.11c.29,0,.62,0,.92,0h1a6.12,6.12,0,0,0,1-.11Q31.86,15.83,31,20.5a64,64,0,0,0-1,8.2c-.56-.08-1-.12-1.27-.15a6.07,6.07,0,0,0-.74,0h-.67a10.77,10.77,0,0,0-1.24.15ZM42.65,27a5.52,5.52,0,0,0,4.65-2.85,12.5,12.5,0,0,0,1.89-7.06,6.08,6.08,0,0,0-1-3.86,3.6,3.6,0,0,0-3-1.39,5.71,5.71,0,0,0-4.84,2.89,12.3,12.3,0,0,0-1.94,7.07,6,6,0,0,0,1.08,3.89A3.91,3.91,0,0,0,42.65,27ZM31.24,39.13q1.71-6,3.19-13.32T37.1,10.39l.89.08h1.44l1-.08-.69,2.67a9.65,9.65,0,0,1,3-2.36,7.6,7.6,0,0,1,3.42-.78A6.11,6.11,0,0,1,51,12a8.17,8.17,0,0,1,1.79,5.56A12.27,12.27,0,0,1,50,25.82a9,9,0,0,1-7.14,3.3A5.25,5.25,0,0,1,39.59,28a5.65,5.65,0,0,1-2-2.87l-.82,4.27a8.3,8.3,0,0,1-.22,1.1q-1,5.19-1.56,8.6L34,39a4.58,4.58,0,0,0-.63-.06,8,8,0,0,0-.89.06,6.13,6.13,0,0,0-1.11.17Zm26.2-21.37h9a9.42,9.42,0,0,1,.09-1c0-.24,0-.53,0-.75a5.45,5.45,0,0,0-.93-3.37A3.07,3.07,0,0,0,63,11.42a4.53,4.53,0,0,0-3.47,1.71,10.18,10.18,0,0,0-2.15,4.67Zm-.35,1.61c0,.41-.08.82-.11,1.22s0,.8,0,1.18a6,6,0,0,0,1.3,4.13A4.75,4.75,0,0,0,62,27.35a6.48,6.48,0,0,0,2.92-.7,11.76,11.76,0,0,0,2.94-2.23l.46.38a11.35,11.35,0,0,0-.5,1.18,12.94,12.94,0,0,0-.41,1.29,13.36,13.36,0,0,1-3,1.48,9.53,9.53,0,0,1-3.11.46A7.81,7.81,0,0,1,55.47,27a8.14,8.14,0,0,1-2.17-5.91,11.72,11.72,0,0,1,2.8-8,9,9,0,0,1,7.07-3.22,6.26,6.26,0,0,1,4.9,2,7.93,7.93,0,0,1,1.77,5.48v.72c0,.36-.06.79-.09,1.3H68.9c-2.78,0-4.75-.08-5.91-.08H60.61l-3.52,0Zm12.76,9.32q1.36-5.28,2.19-10a80.38,80.38,0,0,0,1.07-8.29l.92.11a5.73,5.73,0,0,0,.72,0h.84a6.09,6.09,0,0,0,.91-.11A15.12,15.12,0,0,0,76,12.14c-.13.6-.24,1.24-.32,1.9a11.22,11.22,0,0,1,2.66-3,4.63,4.63,0,0,1,2.74-1,3.25,3.25,0,0,1,.49,0,4.51,4.51,0,0,1,.52.11,13.09,13.09,0,0,0-.37,1.6,15.53,15.53,0,0,0-.16,1.59l-1-.2a4.65,4.65,0,0,0-.74-.06q-2.57,0-3.94,3.25T73.5,28.7l-1.09-.13a7.81,7.81,0,0,0-.8,0h-.56l-1.2.15Zm24.74-1a11.64,11.64,0,0,1-2.74,1.15,11.07,11.07,0,0,1-2.91.38A7.79,7.79,0,0,1,83.15,27a8,8,0,0,1-2.21-5.88,11.29,11.29,0,0,1,2.93-7.9A9.53,9.53,0,0,1,91.22,10a14.3,14.3,0,0,1,3.43.38,10.35,10.35,0,0,1,2.83,1.15,12.19,12.19,0,0,0-.66,1.57,12.77,12.77,0,0,0-.44,1.6h-.56a5.66,5.66,0,0,0-1.77-2.4,4.15,4.15,0,0,0-2.57-.85,6,6,0,0,0-5,2.87,11.8,11.8,0,0,0-2,7,6.75,6.75,0,0,0,1.31,4.46,4.61,4.61,0,0,0,3.74,1.56,7.1,7.1,0,0,0,3.08-.68A6.14,6.14,0,0,0,95,24.75l.53.43q-.27.58-.51,1.2c-.15.42-.28.84-.39,1.28Zm11.54-1.48a9.09,9.09,0,0,1-2.62,2.19,6.17,6.17,0,0,1-2.89.7,4.74,4.74,0,0,1-3.43-1.2,4.29,4.29,0,0,1-1.26-3.25,5,5,0,0,1,1.69-4.06q1.7-1.45,6-2.29l3.14-.62a1.48,1.48,0,0,0,1.08-.92,5.67,5.67,0,0,0,.35-2.25,3,3,0,0,0-.89-2.3,3.22,3.22,0,0,0-2.34-.82,5.71,5.71,0,0,0-3,.78,5.3,5.3,0,0,0-2,2.21l-.66-.17a9,9,0,0,0,.22-1.08,7.16,7.16,0,0,0,.07-1v-.65a11.27,11.27,0,0,1,2.78-1.27,11,11,0,0,1,3-.4A6.57,6.57,0,0,1,109.62,11a4.22,4.22,0,0,1,1.48,3.46,13.1,13.1,0,0,1-.12,1.61q-.12,1-.34,2.06l-1.27,6.48c-.06.29-.11.55-.14.81a5.43,5.43,0,0,0,0,.7,1.14,1.14,0,0,0,.29.83,1.11,1.11,0,0,0,.82.3,2.18,2.18,0,0,0,.47-.06,7.29,7.29,0,0,0,.73-.2l.48,1a8.42,8.42,0,0,1-1.68.75,5.47,5.47,0,0,1-1.58.24,2.44,2.44,0,0,1-1.89-.74,3.22,3.22,0,0,1-.73-2.11ZM107.3,19l-3.07.73a9,9,0,0,0-3.9,1.7,3.56,3.56,0,0,0-1.22,2.8,2.87,2.87,0,0,0,.74,2,2.56,2.56,0,0,0,1.95.78,4.73,4.73,0,0,0,3-1.16,4.44,4.44,0,0,0,1.7-2.67l.79-4.24Zm5.2,9.7q1.36-5.28,2.19-10a80.38,80.38,0,0,0,1.07-8.29l.92.11a5.73,5.73,0,0,0,.72,0h.84a6.09,6.09,0,0,0,.91-.11,15.11,15.11,0,0,0-.47,1.74c-.13.6-.24,1.24-.32,1.9A11.22,11.22,0,0,1,121,11a4.63,4.63,0,0,1,2.74-1,3.26,3.26,0,0,1,.49,0,4.51,4.51,0,0,1,.52.11,13.07,13.07,0,0,0-.37,1.6,15.54,15.54,0,0,0-.16,1.59l-1-.2a4.65,4.65,0,0,0-.74-.06q-2.57,0-3.94,3.25T116.2,28.64l-1.09-.13a7.81,7.81,0,0,0-.8,0h-.56l-1.2.15ZM136.74,26a10.68,10.68,0,0,1-3.09,2.36,8,8,0,0,1-3.46.74,5.8,5.8,0,0,1-4.67-2.1,8.36,8.36,0,0,1-1.77-5.59,12.26,12.26,0,0,1,2.8-8.21,8.79,8.79,0,0,1,7-3.3A5.56,5.56,0,0,1,136.94,11,5.8,5.8,0,0,1,139,13.91l.86-4.23q.57-2.83,1-5.18c.29-1.56.52-3,.73-4.45.46.09.81.15,1.07.18a5.34,5.34,0,0,0,.63,0,7.84,7.84,0,0,0,.87-.06A6.13,6.13,0,0,0,145.3,0q-1.92,7-3.39,14.19t-2.46,14.47l-.89-.09h-1.48l-1,.09.69-2.67Zm-2.85-13.92A5.57,5.57,0,0,0,129.14,15a12.63,12.63,0,0,0-1.89,7.13,6,6,0,0,0,1,3.8,3.61,3.61,0,0,0,3.05,1.32,5.73,5.73,0,0,0,4.9-2.85,12.56,12.56,0,0,0,1.92-7.15A5.69,5.69,0,0,0,137,13.45a3.88,3.88,0,0,0-3.14-1.3Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 256.86 129.92"
                  width="40px"
                >
                  <title>Cartão Elo</title>
                  <g id="Camada_ELO" data-name="Camada ELO">
                    <g id="Camada_ELO-2" data-name="Camada ELO">
                      <path
                        d="M53.59,22.68v0A53.59,53.59,0,0,0,9,105.94L62,82.77l22.1-9.65,21.6-9.44A53.6,53.6,0,0,0,53.59,22.68ZM23.06,79.06c-.08-.92-.13-1.86-.13-2.8A30.65,30.65,0,0,1,76.58,56h0Z"
                      ></path>
                      <path
                        d="M91,114.59c-19.17,18.18-44.57,20-66.87,6.46l12.6-19.16q19,11.38,38.24-3.7l16,16.4Z"
                      ></path>
                      <path
                        d="M112.86,101.33,112.72,0h19.14V98.59a2,2,0,0,0,1.36,2.26l16.7,6.49L142.4,126.9l-19.54-8.26C115.44,115.5,112.86,110.95,112.86,101.33Z"
                      ></path>
                      <path
                        d="M240.57,114.12a53,53,0,0,1-83.84-61.79l20,10.6a30.36,30.36,0,0,0,48.7,34.43l15.15,16.77Z"
                      ></path>
                      <path
                        d="M203.86,21.57a53,53,0,0,1,48,75.46l-20-10.61a30.37,30.37,0,0,0-48.43-34.31L168.28,35.35A52.76,52.76,0,0,1,203.86,21.57Z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 484.49 372.6"
                  width="45px"
                >
                  <title>Cartão Diners Club International</title>
                  <g id="Camada_Diners-Club" data-name="Camada Diners-Club">
                    <g id="Camada_Diners-Club-2" data-name="Camada Diners-Club">
                      <g
                        id="Camada_Diners-Club-3"
                        data-name="Camada Diners-Club"
                      >
                        <path
                          d="M302.18,0H173.43a101.85,101.85,0,1,0,0,203.7H302.18a101.85,101.85,0,1,0,0-203.7ZM173.43,201.43A99.58,99.58,0,1,1,273,101.84h0A99.58,99.58,0,0,1,173.43,201.43Z"
                        ></path>
                        <path
                          d="M153.33,44.36a60.91,60.91,0,0,0,.13,115Z"
                        ></path>
                        <path
                          d="M234.32,101.85a60.91,60.91,0,0,1-40.91,57.53l.13-115a60.91,60.91,0,0,1,40.78,57.49"
                        ></path>
                        <path
                          d="M91.44,254.31c0-10.82-6.39-27.4-30.08-27.4H34.73v1.65c5.25.41,7.93.93,7.93,4.43a29.91,29.91,0,0,1-1.13,6.39L29.27,282.89c-1.75,6.39-3.3,6.7-8.34,7.62v1.65H47C77.27,292.16,91.44,275.12,91.44,254.31ZM39.26,285.06c0-1.65,1.34-6.18,2.27-9.58L53.58,233c.41-1.44.82-3,6.7-3C78.51,230,80,242.67,80,253.08c0,6.28-1,36-33.43,36C41.73,289.07,39.26,288.46,39.26,285.06Z"
                        ></path>
                        <path
                          d="M99.56,293.3c5.77,0,10.3-5.66,14.32-11.74l-1.34-1.13c-4.22,6-7.21,8-8.45,8a1.68,1.68,0,0,1-1.65-1.54c0-1.24,1.24-5.36,1.65-6.8l9.06-33.17-.31-.21c-4,.72-12.57,2.37-16.48,2.57V251c5.67,0,6.49.52,6.49,2.68,0,2.88-8.14,28.43-8.14,33.27C94.72,288.76,94.72,293.3,99.56,293.3Z"
                        ></path>
                        <path
                          d="M111.81,235.72c3.4,0,5-3.19,5-5.25,0-2.27-1.75-5.67-5.15-5.67-2.47,0-4.84,2-4.84,5.56S109.24,235.72,111.81,235.72Z"
                        ></path>
                        <path
                          d="M125,254.26c0,2.16-6.9,26.27-10.1,37.91h7.73c4.22-14,5.56-18.44,10.3-25.54,3.71-5.77,10.2-14.63,15.14-14.63,2,0,2.57,1.44,2.57,3.3,0,4.12-7.62,29.25-7.62,31.73,0,3,.21,6.08,4.94,6.08,5.56,0,9.17-4.74,14.32-11.64l-1.44-1.34c-3.81,4.84-6.39,8.14-8.45,8.14a1.71,1.71,0,0,1-1.65-1.75c0-3.09,8.24-28.53,8.24-33s-2.37-6.8-7.11-6.8c-8.55,0-18,14.32-22.87,21.94l-.21-.21,6.59-21.53-.31-.21c-5.56,1.13-11.12,2.16-16.69,3.19v1.65C124,251.58,125,252.71,125,254.26Z"
                        ></path>
                        <path
                          d="M177.84,293.3c10.3,0,19.67-9.48,20.81-11.12l-1.24-1.24c-5.15,4.22-9.48,7.73-15,7.73-4.33,0-9.68-2.37-9.68-9.37a27.59,27.59,0,0,1,1-6.28l2.88-.41C193.3,270.24,203,261.9,203,253.76c0-4.53-3.19-7-8.45-7-14.52,0-30.8,17.3-30.8,32C163.72,285.26,167,293.3,177.84,293.3Zm-1.65-27.09c3.81-9.17,10.82-17.1,16.38-17.1,2.57,0,3.6,2,3.6,4.12,0,.82-.51,13.18-21.73,17.51Z"
                        ></path>
                        <path
                          d="M212,253.85a49.27,49.27,0,0,1-1.65,8.24L202,292.16h7.83c4.22-13.7,5.67-18.33,9.58-25.75.82-1.55,7-13,10.2-13,2.47,0,.93,3.71,5.36,3.71,1.13,0,4.84,0,4.84-5.36a4.77,4.77,0,0,0-4.53-5h-.41c-6.49,0-14.32,12.05-17.72,18.85l-.82,2.06-.21-.21,5-20.5-.31-.21c-4.64.72-10.71,2.06-16,2.78v1.75a19.37,19.37,0,0,1,3.4-.52C211.51,250.75,212,252.4,212,253.85Z"
                        ></path>
                        <path
                          d="M245.88,291.13c-8.34,0-10-9.48-10.71-14h-1.65l-2.06,16.38h1.65c.62-1.13,1-2.16,2.47-2.16,3,0,7.11,2,10.2,2,5.77,0,15.35-2.58,15.35-13.8,0-8.76-12.57-17.92-12.57-24.41,0-5,3.3-6,5.56-6,6.7,0,9.17,6,9.68,11.85h1.65l2.06-14.32h-1.44a3.09,3.09,0,0,1-2.88,1.85c-3.09,0-5.15-1.75-9.79-1.75C242.48,246.77,241,255,241,258.2c0,7.93,12.26,17.82,12.26,24.62C253.3,286.19,251.65,291.13,245.88,291.13Z"
                        ></path>
                        <path
                          d="M316.93,294c15,0,24.21-10.82,28-15.35l-1.75-1.44c-4.94,4.84-12.15,12.15-23.79,12.15-12.26,0-17.92-8.55-17.92-22,0-15.14,10.51-40.07,31.11-40.07,14.73,0,15.66,13.8,15.86,16.69l1.85.31,3.81-20.5H352c-.51,1-1.13,2.27-4.12,2.27-2.37,0-8.65-2.47-16.07-2.47-23.59,0-41.82,22.76-41.82,42.64C290,286.81,305,294,316.93,294Z"
                        ></path>
                        <path
                          d="M366.18,228.81c0,2.16-14.94,55.93-14.94,58.1,0,2.88.41,6.39,4.94,6.39,6.39,0,10.4-4.94,15.66-12.88l-1.34-.93c-5,6.49-7.21,9.37-9.79,9.37-1.54,0-1.54-1.44-1.54-2.06a33.52,33.52,0,0,1,1-4.84l15.55-59.64-.51-.51a145.64,145.64,0,0,1-16.07,2.78v1.65C361.85,226.14,366.18,226.14,366.18,228.81Z"
                        ></path>
                        <path
                          d="M375.58,251c4.22,0,6.18,0,6.18,3,0,2.78-7.83,28.74-7.83,33.27s2,6.08,5.66,6.08c9.27,0,16.89-12.88,23.9-24.52h.31c-2.37,8.45-4.43,17.1-4.43,19,0,1.54.21,5.36,4.84,5.36,5.15,0,7.83-2.68,14.32-12l-1.44-.93c-3.6,4.53-6.49,8.14-8.45,8.14-1.13,0-1.24-1.13-1.24-1.65,0-1.55,1.34-6.08,2-8.14l8.14-30.8h-7.62c-4,11-6.28,17.51-11.33,25.13-3.5,5.36-10,15-14.42,15-2.16,0-2.47-2.16-2.16-3.5L391.38,247l-.31-.21a135.26,135.26,0,0,1-15.45,2.78Z"
                        ></path>
                        <path
                          d="M432.44,293.3c15.76,0,33-17.82,33-34.09,0-7.52-4.64-15.68-11.86-15.68-9.27,0-14.55,5.15-18,10.51l-.21-.1c3.5-11.64,6.63-23.15,8.9-31.6l-.51-.51c-5.36,1-10.61,1.75-15.76,2.37v1.75c6,.1,6.7.62,6.7,3,0,1.44-.93,4-1.65,6.9l-14,51.61v.41C419,290.1,427,293.3,432.44,293.3Zm-4.53-5.77c1.42-18.3,10.29-38.56,21.62-38.56,6.49,0,7.12,8.38,7.12,11.57,0,8.65-9.79,30.39-23.9,30.39-4.85,0-4.9-2.68-4.85-3.4Z"
                        ></path>
                        <path
                          d="M31.53,315.85c1.75-6.49,3.4-6.7,8.45-7.62v-1.65H14.53v1.65c4.43.51,7.21.82,7.21,4.43A24.59,24.59,0,0,1,20.61,319L8.34,362.16c-1.75,6.39-3.3,6.7-8.34,7.62v1.65H25.13v-1.65c-4.43-.51-7-.82-7-4.12a22.06,22.06,0,0,1,1.13-6.59Z"
                        ></path>
                        <path
                          d="M69.21,367.51a1.71,1.71,0,0,1-1.65-1.75c0-3.09,8.24-28.53,8.24-33s-2.37-6.8-7.11-6.8c-8.55,0-18,14.32-22.87,21.94l-.21-.21,6.59-21.53-.3-.16c-5.56,1.13-11.12,2.16-16.69,3.19v1.65c5.56,0,6.59,1.13,6.59,2.68,0,2.16-6.9,26.27-10.09,37.91h7.73c4.22-14,5.56-18.44,10.3-25.55,3.71-5.77,10.2-14.63,15.14-14.63,2,0,2.58,1.44,2.58,3.3,0,4.12-7.62,29.25-7.62,31.73,0,3,.21,6.08,4.94,6.08,5.56,0,9.17-4.74,14.32-11.64l-1.44-1.34C73.84,364.22,71.27,367.51,69.21,367.51Z"
                        ></path>
                        <path
                          d="M90.34,367.51a1.59,1.59,0,0,1-1.65-1.75,2.27,2.27,0,0,1,.1-.82l9.07-34.3h8.65l.52-3.3H98.79l2.88-10.61c.21-.82,0-1.75-.72-1.54-.93-.21-1.34.72-1.75,1.24-2.88,3.6-7.83,8.24-11.23,10-1.75.93-4.64,1.65-5.25,2.57a2.26,2.26,0,0,0-.21,1.65h7.62L82.72,359c-.41,1.65-2.37,7.93-2.37,9.48,0,3.09,2.88,4.12,4.94,4.12,5.36,0,9.37-4.53,14.63-12.46l-1.34-.72C96,362.67,92.4,367.51,90.34,367.51Z"
                        ></path>
                        <path
                          d="M116.4,351.85c16.69-2.37,26.37-10.71,26.37-18.85,0-4.53-3.19-7-8.45-7-14.52,0-30.8,17.3-30.8,32,0,6.49,3.3,14.52,14.11,14.52,10.3,0,19.67-9.48,20.81-11.12l-1.24-1.24c-5.15,4.22-9.48,7.73-15,7.73-4.33,0-9.68-2.37-9.68-9.37a27.59,27.59,0,0,1,1-6.28Zm-.41-6.39c3.81-9.17,10.82-17.1,16.38-17.1,2.57,0,3.6,2,3.6,4.12,0,.82-.51,13.18-21.73,17.51Z"
                        ></path>
                        <path
                          d="M180,331a4.77,4.77,0,0,0-4.53-5h-.41c-6.49,0-14.32,12-17.72,18.85l-.82,2.06-.21-.21,5-20.5L161,326c-4.64.72-10.71,2.06-16,2.78v1.75a19.37,19.37,0,0,1,3.4-.51c3.19,0,3.71,1.65,3.71,3.09a49.17,49.17,0,0,1-1.65,8.24l-8.34,30.08h7.83c4.22-13.7,5.67-18.34,9.58-25.75.82-1.54,7-13,10.2-13,2.47,0,.93,3.71,5.36,3.71C176.33,336.4,180,336.4,180,331Z"
                        ></path>
                        <path
                          d="M215,367.51a1.71,1.71,0,0,1-1.65-1.75c0-3.09,8.24-28.53,8.24-33s-2.37-6.8-7.11-6.8c-8.55,0-18,14.32-22.87,21.94l-.21-.21,6.6-21.48-.31-.21c-5.56,1.13-11.12,2.16-16.69,3.19v1.65c5.56,0,6.59,1.13,6.59,2.68,0,2.16-6.9,26.27-10.1,37.91h7.72c4.22-14,5.56-18.44,10.3-25.55,3.71-5.77,10.2-14.63,15.14-14.63,2,0,2.57,1.44,2.57,3.3,0,4.12-7.62,29.25-7.62,31.73,0,3,.21,6.08,4.94,6.08,5.56,0,9.17-4.74,14.32-11.64l-1.44-1.34C219.62,364.22,217,367.51,215,367.51Z"
                        ></path>
                        <path
                          d="M270.92,360.1c-4.64,4.53-6.7,7.11-8.24,7.11a1.39,1.39,0,0,1-1.44-1.34h0c0-3.19,9.48-38.32,9.79-39.55l-.72-.31-6.28.72-.31.31-1,4.53h-.21c-.31-2.88-3.71-5.56-8.14-5.56-13.7,0-29.46,19.26-29.46,34.4,0,3,.31,12.15,10.61,12.15,6.18,0,11.64-3.09,20.19-15.66l.21.21c-1.65,6.28-2.16,8.55-2.16,10.92,0,1.75,0,4.43,4.33,4.43s7.93-3.71,14.11-11.33Zm-31.21,7.42c-2.78,0-6.18-1.85-6.18-7.31,0-9.27,9.27-31.93,21.32-31.93,3,0,5.87,2,5.87,6.9,0,10.08-10.1,32.33-21,32.33Z"
                        ></path>
                        <path
                          d="M293.32,316.73c.21-.82,0-1.75-.72-1.54-.93-.21-1.34.72-1.75,1.24-2.88,3.6-7.83,8.24-11.23,10-1.75.93-4.64,1.65-5.25,2.57a2.26,2.26,0,0,0-.21,1.65h7.62L274.37,359c-.41,1.65-2.37,7.93-2.37,9.48,0,3.09,2.88,4.12,4.94,4.12,5.36,0,9.37-4.53,14.63-12.46l-1.34-.72c-2.58,3.3-6.18,8.14-8.24,8.14a1.59,1.59,0,0,1-1.65-1.75,2.27,2.27,0,0,1,.1-.82l9.07-34.3h8.65l.52-3.3h-8.24Z"
                        ></path>
                        <path
                          d="M310,367.72a1.68,1.68,0,0,1-1.65-1.54c0-1.24,1.24-5.36,1.65-6.8l9.06-33.17-.31-.21c-4,.72-12.57,2.37-16.48,2.57v1.65c5.66,0,6.49.51,6.49,2.68,0,2.88-8.14,28.43-8.14,33.27,0,1.85,0,6.39,4.84,6.39,5.77,0,10.3-5.67,14.32-11.74l-1.34-1.13C314.24,365.66,311.25,367.72,310,367.72Z"
                        ></path>
                        <path
                          d="M317.64,304.06c-2.47,0-4.84,2-4.84,5.56s2.37,5.36,4.94,5.36c3.4,0,5-3.19,5-5.25C322.79,307.46,321,304.06,317.64,304.06Z"
                        ></path>
                        <path
                          d="M351.64,326c-15,0-30.28,16.58-30.28,31.73,0,8.55,4.64,14.83,15.55,14.83,15.76,0,29.87-18.64,29.87-31.31C366.79,334.45,363.59,326,351.64,326Zm-13.39,44.4c-5.15,0-8.24-3.71-8.24-9.58,0-12.15,9.37-32.65,20.91-32.65,4.94,0,7.21,4.53,7.21,9.89C358.13,349.07,350,370.4,338.25,370.4Z"
                        ></path>
                        <path
                          d="M401.37,367.51a1.71,1.71,0,0,1-1.65-1.75c0-3.09,8.24-28.53,8.24-33s-2.37-6.8-7.11-6.8c-8.55,0-18,14.32-22.87,21.94l-.21-.21,6.59-21.53-.31-.21c-5.56,1.13-11.12,2.16-16.69,3.19v1.65c5.56,0,6.59,1.13,6.59,2.68,0,2.16-6.9,26.27-10.09,37.91h7.73c4.22-14,5.56-18.44,10.3-25.55,3.71-5.77,10.2-14.63,15.14-14.63,2,0,2.57,1.44,2.57,3.3,0,4.12-7.62,29.25-7.62,31.73,0,3,.21,6.08,4.94,6.08,5.56,0,9.17-4.74,14.32-11.64l-1.44-1.34C406,364.22,403.43,367.51,401.37,367.51Z"
                        ></path>
                        <path
                          d="M449.47,367.2a1.39,1.39,0,0,1-1.44-1.34h0c0-3.19,9.48-38.32,9.79-39.55l-.72-.31-6.28.72-.31.31-1,4.53h-.21c-.31-2.88-3.71-5.56-8.14-5.56-13.7,0-29.46,19.26-29.46,34.4,0,3,.31,12.15,10.61,12.15,6.18,0,11.64-3.09,20.19-15.66l.21.21c-1.65,6.28-2.16,8.55-2.16,10.92,0,1.75,0,4.43,4.33,4.43s7.93-3.71,14.11-11.33l-1.24-1C453.07,364.63,451,367.2,449.47,367.2Zm-23,.31c-2.78,0-6.18-1.85-6.18-7.31,0-9.27,9.27-31.93,21.32-31.93,3,0,5.87,2,5.87,6.9,0,10.09-10.07,32.34-21,32.34Z"
                        ></path>
                        <path
                          d="M469.48,368.13c-1.54,0-1.54-1.44-1.54-2.06a33.45,33.45,0,0,1,1-4.84l15.55-59.64-.52-.52a145.52,145.52,0,0,1-16.07,2.78v1.65c2.68-.1,7-.1,7,2.58,0,2.16-14.94,55.93-14.94,58.1,0,2.88.41,6.39,4.94,6.39,6.39,0,8.39-2.13,13.65-10.06l-1.34-.93C472.21,368.06,472.06,368.13,469.48,368.13Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 168.56 58.95"
                  width="50px"
                >
                  <title>Cartão American Express</title>
                  <g
                    id="Camada_American-Express"
                    data-name="Camada American Express"
                  >
                    <g
                      id="Camada_American-Express-2"
                      data-name="Camada American Express"
                    >
                      <path
                        d="M106,40.72h0c-1.74-.08-3.48,0-5.23,0a.56.56,0,0,0-.41.37c0,1.21,0,2.41,0,3.6h5.42a2,2,0,0,0,2.17-1.81V42.8A2,2,0,0,0,106,40.72Z"
                      ></path>
                      <polygon
                        points="121.42 7.92 121.19 7.92 118.61 14.32 124.01 14.32 121.42 7.92"
                      ></polygon>
                      <path
                        d="M86.76,40.76h-.08c-1.74-.07-3.49,0-5.24,0-.15,0-.42.23-.42.36,0,1.3,0,2.62,0,4h5.5a2.08,2.08,0,0,0,2.23-1.91q0-.08,0-.17A2.14,2.14,0,0,0,86.76,40.76Z"
                      ></path>
                      <path
                        d="M83,7.54H77.93c-.41,0-.54.16-.54.56V11c0,.43.13.6.57.58.81-.07,1.66,0,2.53,0H82.9A2,2,0,0,0,85,9.65s0-.07,0-.1A2,2,0,0,0,83,7.54Z"
                      ></path>
                      <polygon
                        points="15.69 7.88 15.48 7.88 12.89 14.32 18.29 14.31 15.69 7.88"
                      ></polygon>
                      <path
                        d="M154.16.1H143.89V4.21l-.16.06-1.2-1.86c-.4-.62-.87-1.79-1.58-2.19S139.21.1,138.31.1h-7.46c-1,0-1,0-1,1,0,2.1,0,4.19-.09,6.31l-2.47-5.76C126.63.1,126.63.1,125,.1H108a12.6,12.6,0,0,0-8,2.56l-.31.18V.64c0-.41-.15-.58-.56-.54h-57c-.67,0-1,.17-1.19.82-.48,1.53-1,3-1.63,4.73L38.2,2.51c-.22-.63-.46-1.26-.66-1.9A.64.64,0,0,0,36.81.1h-12c-.56,0-.67.21-.67.71,0,2.19,0,4.39-.07,6.61l-1.68-3.9c-.41-.94-.84-1.88-1.2-2.84a.8.8,0,0,0-.9-.58H11.16a1,1,0,0,0-1.09.71c-1.66,4-3.37,7.92-5,11.85L.14,25.12s-.75.59,1.17.5c1.39-.06,3-.06,3.72-.06H11.2a.89.89,0,0,0,1-.68c.32-.9.72-1.78,1.06-2.68a.72.72,0,0,1,.78-.55H17.2a.73.73,0,0,1,.8.54c.35.92.75,1.82,1.09,2.74a.81.81,0,0,0,.95.64H79.39c.59.07.79-.19.77-.77V21.69c1,1.21,1.87,2.26,2.72,3.35a1.3,1.3,0,0,0,1.14.54H98.93c.63,0,.91-.17.85-.83a17.22,17.22,0,0,1,0-1.76,5.42,5.42,0,0,1,.5.3,11.13,11.13,0,0,0,6.35,2.21c3.44.07,6.89.07,10.33.12a.82.82,0,0,0,.9-.61c.34-.92.75-1.82,1.08-2.74a.74.74,0,0,1,.84-.56h3a.79.79,0,0,1,.9.59c.34.94.72,1.88,1.15,2.79a1,1,0,0,0,.73.5h14.91c.5,0,.66-.21.65-.69V21.21c.8,1.25,1.56,2.32,2.2,3.45a1.68,1.68,0,0,0,1.72.94h9.07c.69,0,.87-.22.87-.89V.93C155,.29,154.81.09,154.16.1ZM22,22.32a.87.87,0,0,1-.6-.47c-.43-1-.82-1.93-1.2-2.91a.69.69,0,0,0-.75-.51H11.71a.64.64,0,0,0-.69.48c-.38,1-.76,2-1.18,2.92-.09.21-.34.48-.52.48h-5L5,21.11l.74-1.8Q9,11.72,12.29,4.08a.87.87,0,0,1,.94-.63h4.9a.84.84,0,0,1,.9.61l7.61,17.8a4,4,0,0,1,.13.46Zm29.22-.68c0,.53-.15.71-.69.69H47.35c-.62,0-.8-.17-.8-.79V8.5l-.2-.05c-.1.22-.21.43-.29.66-1.48,4.14-3,8.28-4.41,12.44-.19.55-.44.79-1,.75a20.94,20.94,0,0,0-2.62,0,.85.85,0,0,1-1-.69q-2.19-6.23-4.42-12.43c-.09-.24-.19-.48-.29-.71h-.18v13c0,.63-.18.81-.8.78H28.17c-.43,0-.6-.12-.6-.57V4c0-.46.19-.57.6-.57h6.45c.52,0,.63.3.76.67L39.11,14.7c.07.21.16.41.24.61l.14.06c.17-.45.35-.9.51-1.35,1.15-3.29,2.3-6.57,3.43-9.87a.84.84,0,0,1,.94-.7h6.11c.56,0,.72.17.72.73Zm18.67.08c0,.51-.12.7-.67.7h-14c-.5,0-.66-.16-.65-.65-.06-3-.06-6-.06-8.9V4.21c0-.59.17-.76.76-.76H69.09c.57,0,.81.13.77.75a22.91,22.91,0,0,0,0,2.62c0,.62-.2.75-.77.74H60c-.66,0-.88.21-.83.84a11.25,11.25,0,0,1,0,1.61c0,.57.15.78.75.77h8.87c.7,0,.89.2.85.87a24,24,0,0,0,0,2.55c0,.5-.15.66-.65.65H60c-.67,0-.94.17-.88.86a14.3,14.3,0,0,1,0,1.81c0,.52.17.69.7.69H69c.64,0,.87.16.83.82C69.82,19.92,69.87,20.82,69.87,21.72Zm17.19.6a3.29,3.29,0,0,1-3.32-1.52c-1.26-1.7-2.72-3.27-4.09-4.89a2.35,2.35,0,0,0-2.1-.35.84.84,0,0,0-.18.59v5.44c0,.56-.16.74-.72.72H73.5c-.59,0-.77-.15-.77-.75V4.17c0-.54.14-.75.72-.74H83.79a5.72,5.72,0,0,1,5.85,5.31,5.82,5.82,0,0,1-4.15,6.44l-.8.26,6.11,6.88A35,35,0,0,0,87.06,22.32Zm9.39-.62c0,.46-.13.64-.61.63H92.49c-.56,0-.68-.2-.68-.7,0-2.91,0-5.82,0-8.72V4.26c0-.6.16-.84.79-.81h3.22c.45,0,.64.12.63.61Zm11.67.29a.73.73,0,0,1-.57.31c-4.55-.18-7.82-2.49-8.47-7.45a10.9,10.9,0,0,1,1.48-7.91,7.89,7.89,0,0,1,6.3-3.44c2-.13,3.93,0,5.9-.06.46,0,.64.15.63.62v3c0,.49-.14.67-.65.66h-4.16c-3,0-4.87,1.69-5,4.74a8.85,8.85,0,0,0,.37,2.76,4.11,4.11,0,0,0,4,3c.59,0,1.21,0,2,0C109.28,19.53,108.72,20.77,108.12,22Zm19.37.32c-.16,0-.38-.28-.46-.47q-.62-1.41-1.17-2.85a.73.73,0,0,0-.78-.55h-7.66a.71.71,0,0,0-.77.56q-.54,1.44-1.16,2.86c-.09.2-.35.46-.54.46h-4.74c.1-.29.17-.51.26-.72q3.75-8.75,7.49-17.51a.87.87,0,0,1,.94-.64h4.9a.79.79,0,0,1,.87.54q3.78,8.88,7.59,17.75a1.66,1.66,0,0,1,.23.57Zm24-.49c0,.4-.12.56-.54.56h-4.7a1.14,1.14,0,0,1-.75-.51c-2.25-3.47-4.47-7-6.7-10.44-.22-.35-.46-.69-.7-1l-.19-.06V21.56c0,.58-.14.79-.75.77h-3.36c-.44,0-.64-.1-.64-.59V4.08c0-.47.15-.63.62-.62h4.9a1,1,0,0,1,.88.58l6.57,10.21c.17.27.38.53.56.79h.18V4.28c0-.58.14-.8.75-.77h3.29c.44,0,.58.16.58.59Z"
                      ></path>
                      <path
                        d="M165.67,33.32l-.49,0a3.33,3.33,0,0,1-.69,0H69.18a1.66,1.66,0,0,0-1.56.77c-.7,1-1.49,2-2.28,3-.86-1.12-1.7-2.17-2.49-3.24a1.12,1.12,0,0,0-1-.49H36.46c-.57,0-.77.13-.76.74v24c0,.58.16.78.75.77H61.7a1.19,1.19,0,0,0,1.06-.56c.79-1.21,1.61-2.27,2.47-3.39.85,1.12,1.68,2.17,2.47,3.24a1.24,1.24,0,0,0,1.12.57H83.4c.87,0,.89,0,.89-.92v-4c0-.93,0-.9.9-.94,1.74-.07,3.48-.14,5.21-.29a9.91,9.91,0,0,0,1.85-.53v6c0,.51.15.73.68.72h9.47c.49,0,.68-.19.68-.68V55l.75.89c.65.8,1.31,1.59,1.94,2.41a1.29,1.29,0,0,0,1.14.54H155a27.32,27.32,0,0,0,4.89-.07,11.17,11.17,0,0,0,4.75-1.25c.3-.14.59-.29.85-.44l.2-.12a6.42,6.42,0,0,0,2.89-3.19V33.32ZM54.4,40c0,.53-.15.7-.68.69H44.59c-.65,0-.88.19-.82.83a8.14,8.14,0,0,1,0,1.61c-.07.68.17.89.85.88h8c1.51,0,1.51,0,1.51,1.53v1.75c0,.58-.16.69-.69.69H44.71c-.94,0-.94,0-.94.94v2.35h9.82c.6,0,.85.12.81.77-.06.94,0,1.88,0,2.82,0,.41-.09.61-.56.61H39.6c-.61,0-.55-.35-.55-.75V37.24c0-.45.16-.58.59-.58H53.81c.5,0,.6.2.59.64ZM70,55.55c-.2,0-.44-.28-.59-.48-1.22-1.57-2.42-3.16-3.63-4.74l-.57-.76-2,2.62c-.73,1-1.45,1.93-2.2,2.88a1,1,0,0,1-.56.41H55l1.81-2.29c1.76-2.2,3.51-4.41,5.3-6.59a.72.72,0,0,0,.06-1l-.06-.06q-3.37-4.17-6.71-8.38l-.32-.45h5.14a1.18,1.18,0,0,1,1.07.53c1.18,1.57,2.39,3.13,3.59,4.69l.48.59c.24-.29.44-.52.62-.76,1.19-1.54,2.36-3.09,3.56-4.62a1,1,0,0,1,.63-.4h5.28a5.45,5.45,0,0,1-.3.49c-2.2,2.74-4.39,5.48-6.61,8.2a.81.81,0,0,0-.1,1.14l.1.1c2.23,2.75,4.42,5.52,6.62,8.28l.46.62Zm18.37-6.38a10.53,10.53,0,0,1-1.86.19c-1.81,0-3.61,0-5.53,0v5.39c0,.61-.14.83-.78.8-1.12,0-2.24,0-3.35,0-.48,0-.61-.17-.61-.63V37.3c0-.51.16-.65.66-.65H87.5a5.91,5.91,0,0,1,5.87,5.85A6.06,6.06,0,0,1,88.37,49.17Zm19.82,6.32c-.22,0-.48-.29-.66-.5-1.57-1.84-3.13-3.68-4.67-5.54a1.45,1.45,0,0,0-1.42-.66,8.09,8.09,0,0,1-1.08,0v6c0,.55-.18.69-.7.68H96.37c-.58,0-.77-.15-.76-.75V37.18c0-.37.13-.52.51-.52,3.65,0,7.3-.06,10.94,0a5.7,5.7,0,0,1,5.5,5,5.89,5.89,0,0,1-4.16,6.73l-.78.24,6.1,6.86ZM130,54.9c0,.45-.12.63-.61.63H115.26c-.44,0-.59-.14-.59-.58V37.29c0-.48.17-.61.62-.61h14.1c.52,0,.65.19.64.67V40.1c0,.56-.21.67-.71.67h-9.13c-.59,0-.87.13-.81.78a11,11,0,0,1,0,1.81c0,.57.19.73.73.73h9.13c.38,0,.51.16.51.52v2.75c0,.54-.17.69-.69.68h-8.73c-.94,0-.94,0-.94.94,0,.7,0,1.46,0,2.34h9.88c.59,0,.79.16.76.76Zm18.46-4.52a5.35,5.35,0,0,1-5.39,4.93c-2.4.18-4.82.1-7.24.13H133c-.38,0-.59-.09-.58-.52V51.77c0-.56.34-.52.71-.52h9.13a1.57,1.57,0,0,0,1.59-2.12A1.62,1.62,0,0,0,142.22,48h-4.77a6.06,6.06,0,0,1-4-1.41c-2.57-2.29-2.38-8.06,2.07-9.58a8,8,0,0,1,2.42-.42h9.53l.68.06c-.59,1.33-1.12,2.56-1.7,3.76-.08.16-.44.26-.67.26h-7.52a1.61,1.61,0,0,0-1.79,1.9c.1.85.81,1.38,1.92,1.39h5C147.39,44.17,149.05,47,148.5,50.38Zm17.17,1v0c-.05.17-.13.32-.19.48a4.78,4.78,0,0,1-.42.72l0,0a5.63,5.63,0,0,1-4.56,2.75c-.6,0-1.2.1-1.8.11h-8.26c-.54,0-.77-.12-.74-.71V51.92c0-.54.17-.68.69-.68h9c1.2,0,1.88-.58,1.87-1.6s-.71-1.6-1.9-1.6h-4.56a5.57,5.57,0,0,1-4.6-2.06,5.89,5.89,0,0,1,3.63-9.23,9.68,9.68,0,0,1,1.66-.14h9.26l.69,0,0,.26c-.54,1.23-1,2.36-1.57,3.46a1,1,0,0,1-.76.34h-7.45a1.66,1.66,0,0,0-1.76,1.15,1.55,1.55,0,0,0,.94,2l.06,0a3.68,3.68,0,0,0,1,.15h4.83c2.51.1,4.23,1.33,4.87,3.38v-.12A5.57,5.57,0,0,1,165.67,51.38Z"
                      ></path>
                      <path d="M165.54,57.23"></path>
                    </g>
                  </g>
                </svg>
              </li>
              <li>
                <img
                  src="https://multiar.vteximg.com.br/arquivos/pix.jpg?v=637418302101000000"
                  width="35px"
                  alt="Forma de pagamento PIX"
                  title="PIX"
                />
              </li>
              <li>
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="45px"
                  viewBox="0 0 101 101"
                >
                  <title>Boleto Bancário</title>
                  <path
                    d="M21.5,33A1.5,1.5,0,0,0,20,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,21.5,33Z"
                  />
                  <path
                    d="M29.5,33A1.5,1.5,0,0,0,28,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,29.5,33Z"
                  />
                  <path
                    d="M34.5,33A1.5,1.5,0,0,0,33,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,34.5,33Z"
                  />
                  <path
                    d="M63.5,33A1.5,1.5,0,0,0,62,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,63.5,33Z"
                  />
                  <path
                    d="M68.5,33A1.5,1.5,0,0,0,67,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,68.5,33Z"
                  />
                  <path
                    d="M45.5,33A1.5,1.5,0,0,0,44,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,45.5,33Z"
                  />
                  <path
                    d="M55.5,33A1.5,1.5,0,0,0,54,34.5v32a1.5,1.5,0,0,0,3,0v-32A1.5,1.5,0,0,0,55.5,33Z"
                  />
                  <path
                    d="M82,66.5v-32a1.5,1.5,0,0,0-3,0v32a1.5,1.5,0,0,0,3,0Z"
                  />
                  <path
                    d="M10.5,38A1.5,1.5,0,0,0,12,36.5V28h8.5a1.5,1.5,0,0,0,0-3h-10A1.5,1.5,0,0,0,9,26.5v10A1.5,1.5,0,0,0,10.5,38Z"
                  />
                  <path
                    d="M91.5,25h-10a1.5,1.5,0,0,0,0,3H90v8.5a1.5,1.5,0,0,0,3,0v-10A1.5,1.5,0,0,0,91.5,25Z"
                  />
                  <path
                    d="M20.5,74H12V66.5a1.5,1.5,0,0,0-3,0v9A1.5,1.5,0,0,0,10.5,77h10a1.5,1.5,0,0,0,0-3Z"
                  />
                  <path
                    d="M91.5,65A1.5,1.5,0,0,0,90,66.5V74H81.5a1.5,1.5,0,0,0,0,3h10A1.5,1.5,0,0,0,93,75.5v-9A1.5,1.5,0,0,0,91.5,65Z"
                  />
                </svg>
              </li>
              <li>Pague com 2 cartões</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__copyright">
      <p>
        © {{ new Date().getFullYear() }} Leverosintegra.com.br. Todos os
        direitos reservados.
      </p>
      <p>Powered by <span>Profiz</span></p>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    showOptionsMenu() {
      if (window.innerWidth <= 768) {
        var groups = document.getElementsByClassName("footer__title");

        for (let i = 0; i < groups.length; i++) {
          groups[i].addEventListener("click", function () {
            this.classList.toggle("ativo");
            var menus = this.nextElementSibling;
            if (menus.style.maxHeight) {
              menus.style.maxHeight = null;
            } else {
              menus.style.maxHeight = menus.scrollHeight + "px";
            }
          });
        }
      }
    },
  },

  mounted() {
    this.showOptionsMenu();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--customWhite);
  margin-top: 30px;

  &__content {
    margin: 0 auto;
    padding: 30px 0;
    border-bottom: 1px solid var(--customGray-70);
    max-width: 100%;

    @media (min-width: 769px) and (max-width: 1919px) {
      display: flex;
      max-width: 90%;
    }

    @media (min-width: 1920px) {
      max-width: 70%;
    }
  }

  &__logo {
    width: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 911px) {
      width: 20%;
      padding: 0;
    }
  }

  &__drops {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;

    @media (min-width: 769px) {
      flex-direction: row;
    }
  }

  &__climatizacao {
    margin-top: 35px;
  }

  &__climatizacao,
  &__solar {
    p {
      color: var(--standardGreen);
      font: 700 0.95rem "Soleto", sans-serif;
    }
  }

  &__socialMedias {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      padding: 15px 5px;
    }

    svg {
      fill: var(--standardGreen);
    }
  }

  &__CallCenter,
  &__institutional,
  &__partners,
  &__payment {
    padding: 15px;
    text-align: center;

    @media (min-width: 911px) {
      width: 20%;
      padding: 0;
      text-align: left;
    }

    .CallCenter {
      &__solar {
        margin-top: 35px;
      }
    }
  }

  &__title {
    font: 700 1rem "Soleto", sans-serif;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      &:after {
        content: "\f054";
        font-family: "FontAwesome";
        font-size: 13px;
        color: #777;
        float: right;
        margin-left: 5px;
      }
    }
  }

  &__items {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
    text-align: left;
    padding-top: 15px;

    @media (min-width: 769px) {
      overflow: visible;
      max-height: inherit;
    }
    p,
    span {
      a {
        text-decoration: none;
        line-height: 1.7;
        color: var(--customGray-500);
        font-size: 0.915rem;
        transition: all 0.2s;

        &:hover {
          font-weight: bold;
        }
      }
    }

    &--bold {
      p:nth-child(even) {
        color: var(--customDarkGreen);
        font: 700 0.975rem "Soleto", sans-serif;
      }

      p {
        padding: 5px 0;
        color: var(--customGray-500);
        font-size: 0.915rem;
      }

      p a {
        text-decoration: none;
        line-height: 1.7;
        color: var(--customGray-500);
        font-size: 0.915rem;
      }
    }

    &--methods {
      ul {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        li {
          list-style: none;
          padding: 7px;
          width: 50%;

          @media (min-width: 461px) {
            width: 30%;
          }

          &:last-child {
            font-size: 0.788rem;
          }
        }
      }
    }
  }

  &__copyright {
    max-width: 85%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    color: var(--customGray-500);
    font-size: 0.85rem;
    flex-direction: column;
    text-align: center;

    @media (min-width: 461px) and (max-width: 1366px) {
      flex-direction: row;
      text-align: left;
    }

    @media (min-width: 1367px) {
      max-width: 65%;
      flex-direction: row;
    }

    p {
      line-height: 1.9;
    }

    p span {
      color: var(--greenProfiz);
      font-weight: bold;
    }
  }
}

.ativo {
  @media (max-width: 768px) {
    &::after {
      content: "\f078";
      font-family: "FontAwesome";
    }
  }
}
</style>